export default "__VITE_ASSET__CZorPWEu__"